import { FuseConfig } from '@fuse/types';


export const fuseConfig: FuseConfig = {
    // Color themes can be defined in src/app/app.theme.scss
    colorTheme: 'theme-blue-gray-dark',
    layout: {
        style: 'vertical-layout-1'
    }
};
